import React, { useState } from "react";

import { FormButton } from "components";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";

import { Form, Formik } from "formik";
import * as yup from "yup";

import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    rowSelected,
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";

import { FORM_ERROR_MESSAGES } from "consts/errorMessages";

import styles from "styles/pages/ModalActions.module.scss";
import { handleResponse } from "services/Local-services";
import { horarioUpd } from "services/services-mia/miakey";
import { codRegex, customRegex } from "../Horarios";

export default function UpdateModal({ updateList, horario, closeModal }) {
    const setSelected = useSetRecoilState(rowSelected);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);

    const [inRequest, setInRequest] = useState(false);

    const handleSubmit = async ({
        nombre,
        descripcion,
        cod
    }) => {
        setInRequest(true);

        const response = await horarioUpd({
            gateHorarioId: horario.gateHorarioId,
            gateHorarioNombre: nombre,
            gateHorarioDescripcion: descripcion,
            gateHorarioVersion: horario.gateHorarioVersion,
            gateHorarioCod: cod
        }, credentials);

        const functions = {
            setSnackbarInfo,
            setIsOpen: closeModal,
            setSelected,
            updateList,
        };

        handleResponse(
            response,
            "Horario modificado exitosamente",
            functions
        );

        setInRequest(false);
    };

    return (
        <Formik
            initialValues={{
                nombre: horario.gateHorarioNombre ?? "",
                descripcion: horario.gateHorarioDescripcion ?? "",
                cod: horario.gateHorarioCod ?? ""
            }}
            validationSchema={
                yup.object({
                    nombre: yup.string(FORM_ERROR_MESSAGES.text)
                        .min(2, "Debe tener minimo 2 caracteres")
                        .max(45, "Debe tener un maximo de 45 caracteres")
                        .matches(
                            customRegex,
                            "Formato inválido"
                        )
                        .required(FORM_ERROR_MESSAGES.required),
                    descripcion: yup.string(FORM_ERROR_MESSAGES.text)
                        .min(2, "Debe tener minimo 2 caracteres")
                        .max(255, "Debe tener un maximo de 255 caracteres")
                        .matches(
                            customRegex,
                            "Formato inválido"
                        )
                        .required(FORM_ERROR_MESSAGES.required),
                    cod: yup.string(FORM_ERROR_MESSAGES.text)
                        .max(15, "Debe tener un maximo de 15 caracteres")
                        .matches(
                            codRegex,
                            "Debe tener solo letras y/o números"
                        )
                        .required(FORM_ERROR_MESSAGES.required)
                })
            }
            onSubmit={(values, { setSubmitting }) => {
                try {
                    handleSubmit(values);
                } catch (e) {
                    setSnackbarInfo({
                        message: e.errmsg,
                        severity: "error",
                        open: true,
                    });
                } finally {
                    setSubmitting(false);
                }
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column-sm"]}>
                    <FormikTextInput
                        fullWidth={true}
                        name="nombre"
                        labelText="Horario"
                        placeholder="Ingrese nombre"
                    />
                    <FormikTextInput
                        fullWidth={true}
                        name="descripcion"
                        labelText="Descripción"
                        placeholder="Ingrese descripción"
                    />
                    <FormikTextInput
                        fullWidth={true}
                        name="cod"
                        labelText="Código"
                        placeholder="Ingrese código"
                    />
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Guardar cambios" }}
                        onCloseModal={closeModal}
                    />
                </div>
            </Form>
        </Formik>
    );
}
